import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaionlinecabbooking() {



  const cardData =
  {
    keyword: 'Pune to Mumbai Online Cab Booking',
    heading: 'Sai Trupti Cabs: Pune to Mumbai Online Cab Booking',
    headingDescription: 'Sai Trupti Cabs offers convenient and reliable Pune to Mumbai online cab booking services, making intercity travel easy, fast, and hassle-free. With just a few clicks, you can book your preferred Sedan, SUV, or Luxury cab from the comfort of your home and enjoy a smooth ride between Pune and Mumbai. All our vehicles are clean, air-conditioned, and equipped for maximum comfort, ensuring a pleasant journey for families, professionals, and solo travelers alike. Our experienced and background-verified chauffeurs ensure punctual pickups, safe driving, and courteous service every time. Whether it’s an airport transfer, business trip, or weekend getaway, Sai Trupti Cabs guarantees transparent pricing, instant confirmations, and 24×7 support. Experience effortless travel with Sai Trupti Cabs — your trusted choice for Pune to Mumbai online cab booking.',

    top: 'Top Places to Visit in Mumbai with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most iconic landmark, overlooking the Arabian Sea in majestic grandeur. Built in 1924 to commemorate King George V’s visit, it blends Indo-Saracenic architecture with colonial elegance. Tourists flock here to enjoy ferry rides to Elephanta Island and admire the sun setting behind the monument. Surrounded by historic hotels and lively street vendors, it is the perfect starting point for exploring South Mumbai’s heritage charm."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, famously known as the Queen’s Necklace, is a 3.6 km boulevard curving gracefully along the Arabian Sea. At night, its glittering streetlights resemble a necklace of pearls, enchanting both locals and travelers. The promenade is perfect for evening strolls, jogs, or simply sitting by the sea breeze. Watching the sunset here with the skyline of Mumbai shimmering in the background offers one of the most serene moments in the bustling metropolis."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "A UNESCO World Heritage Site, Chhatrapati Shivaji Maharaj Terminus is a masterpiece of Victorian Gothic architecture fused with Indian artistry. Built in 1887, this grand railway station pulsates with Mumbai’s heartbeat as thousands commute daily. The ornate domes, pointed arches, and stained glass windows narrate stories of the city’s colonial past. It remains not just a transport hub but an architectural marvel symbolizing Mumbai’s vibrant spirit."
  },
  {
    "title": "Elephanta Caves",
    "description": "Situated on Elephanta Island, about 10 km from Mumbai’s shore, the Elephanta Caves are a UNESCO-listed heritage site dating back to the 5th century. These rock-cut temples are dedicated to Lord Shiva and feature magnificent sculptures, including the colossal Trimurti idol. Accessible by ferry from the Gateway of India, the island offers a mix of history, spirituality, and scenic charm. Visitors are captivated by its ancient artistry and tranquil surroundings."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most beloved seaside destinations, stretching over six kilometers along the Arabian coast. Locals and tourists gather here to relish iconic street foods like pav bhaji, bhel puri, and gola. The evenings come alive with laughter, vendors, and the sound of crashing waves. Watching planes land nearby at sunset makes this beach a truly cinematic Mumbai experience. It’s where relaxation meets the vibrant pulse of city life."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah stands gracefully on a tiny islet off Worli, connected to the mainland by a narrow causeway. Built in the 15th century, it houses the tomb of the revered Sufi saint Pir Haji Ali Shah Bukhari. The white marble structure surrounded by the sea exudes spiritual peace and architectural beauty. At high tide, the path gets submerged, making the shrine appear to float on water—a breathtaking symbol of faith amidst Mumbai’s urban energy."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Spread across 100 square kilometers, Sanjay Gandhi National Park is a lush green oasis within the city limits of Mumbai. It offers nature trails, waterfalls, boating, and even a mini zoo for families. The ancient Kanheri Caves nestled inside the park showcase Buddhist rock-cut architecture dating back over 2,000 years. A favorite weekend escape for Mumbaikars, the park perfectly balances nature, history, and adventure in one breathtaking expanse."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "The Shree Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most revered spiritual landmarks dedicated to Lord Ganesha. Built in 1801, it attracts devotees from across India, including film stars and politicians. The temple’s golden dome and intricately carved idol radiate divine grace. Devotees believe that praying here fulfills wishes, making it a hub of faith, devotion, and cultural unity in the heart of Mumbai."
  },
  {
    "title": "Colaba Causeway Market",
    "description": "Colaba Causeway is Mumbai’s vibrant shopping street known for its eclectic mix of fashion, handicrafts, antiques, and cafés. Whether you’re hunting for souvenirs, jewelry, or bohemian clothing, this market offers it all at irresistible prices. The charming colonial architecture adds to its nostalgic charm. With nearby attractions like the Gateway of India and Leopold Café, Colaba represents the city’s cosmopolitan soul and artistic flair."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a marvel of modern engineering connecting South Mumbai with the western suburbs. Its cable-stayed structure gleams over the Arabian Sea, especially when illuminated at night. Driving across this eight-lane bridge offers panoramic skyline views and a glimpse of Mumbai’s futuristic spirit. The Sea Link is not just a roadway but a symbol of progress, resilience, and Mumbai’s forward-moving ambition."
  }
],



"services": [
  {
    "name": "Pune to Mumbai Online Cab Booking",
    "description": "Pune to Mumbai Online Cab Booking provides travelers with a seamless digital platform to reserve cabs for intercity travel. With user-friendly interfaces, customers can select vehicle types, schedule pickups, and receive instant confirmations. The platform supports multiple payment options, fare transparency, and easy cancellation or rescheduling, making it ideal for business travelers, families, and tourists seeking convenience. Advanced features such as real-time tracking, driver details, and estimated travel times ensure a smooth and stress-free journey between Pune and Mumbai."
  },
  {
    "name": "Pune to Mumbai Cab Service",
    "description": "Pune to Mumbai Cab Service offers reliable and professional intercity transportation for passengers traveling between Pune and Mumbai. The service provides a wide range of vehicles, from economy cars to premium sedans and SUVs, ensuring comfort and safety. Drivers are trained and knowledgeable about the routes, offering timely pickups and drop-offs. With transparent pricing, 24/7 availability, and excellent customer support, this cab service caters to both individual and group travel, ensuring a hassle-free and enjoyable journey."
  },
  {
    "name": "Pune to Mumbai Taxi Online",
    "description": "Pune to Mumbai Taxi Online allows passengers to book taxis for intercity travel via mobile or web platforms, ensuring convenience at every step. Customers can choose from hatchbacks, sedans, SUVs, or luxury vehicles, depending on their needs. Real-time ride tracking, instant fare estimates, and multiple payment options enhance the overall travel experience. The service focuses on punctuality, driver professionalism, and vehicle cleanliness, making online taxi booking a reliable and efficient choice for those traveling between Pune and Mumbai."
  },
  {
    "name": "Pune to Mumbai Car Rental Booking",
    "description": "Pune to Mumbai Car Rental Booking offers a wide selection of cars for rent, including self-drive and chauffeur-driven options. The service ensures flexibility, comfort, and transparency for travelers planning trips between Pune and Mumbai. Customers can choose from hatchbacks, sedans, SUVs, or luxury vehicles, with detailed pricing and rental policies available online. Timely delivery of vehicles, professional driver services, and 24/7 support make this car rental service convenient and dependable for business trips, family travel, or leisure excursions."
  },
  {
    "name": "Pune to Mumbai Innova Booking",
    "description": "Pune to Mumbai Innova Booking specializes in reservations for Toyota Innovas, ideal for family groups or travelers seeking spacious, comfortable rides. The booking service offers one-way or round-trip options with transparent pricing, professional drivers, and air-conditioned interiors. Customers can easily schedule pickups and drop-offs online, track their ride in real-time, and access 24/7 support for a seamless travel experience. This service ensures reliability, comfort, and convenience for intercity travel between Pune and Mumbai."
  },
  {
    "name": "Pune to Mumbai Sedan Booking",
    "description": "Pune to Mumbai Sedan Booking provides an easy way to reserve mid-sized sedans for intercity travel. Sedans like Honda City, Hyundai Verna, and Toyota Etios offer a balance of comfort, style, and affordability. The online booking platform allows travelers to select pickup points, schedule trips, and confirm fares instantly. With well-maintained vehicles, experienced drivers, and 24/7 customer support, this service ensures a smooth and professional journey for corporate clients, families, and individual travelers between Pune and Mumbai."
  },
  {
    "name": "Pune to Mumbai Ertiga Booking",
    "description": "Pune to Mumbai Ertiga Booking enables customers to reserve Maruti Ertiga vehicles, perfect for small families or groups. The service provides spacious seating, air-conditioned comfort, and safe travel for one-way or round-trip journeys. With transparent fare information, instant confirmations, and convenient online management of bookings, customers enjoy hassle-free intercity travel. Experienced drivers familiar with the Pune-Mumbai route ensure timely pickups and smooth rides, making Ertiga Booking a reliable choice for group travel."
  },
  {
    "name": "Pune to Mumbai One Way Booking",
    "description": "Pune to Mumbai One Way Booking specializes in single-trip cab reservations for passengers who don’t require a return journey. This service offers a cost-effective solution without compromising on comfort or safety. Customers can choose from various vehicle types including hatchbacks, sedans, SUVs, and luxury cars. The platform provides instant fare estimates, online confirmations, and flexible payment options. Timely pickups, professional drivers, and clean, well-maintained vehicles make this service ideal for airport transfers, business trips, or casual travel."
  },
  {
    "name": "Pune to Mumbai Airport Cab Booking",
    "description": "Pune to Mumbai Airport Cab Booking offers dedicated services for travelers heading to or from Mumbai airports. The service ensures punctual pickups, real-time vehicle tracking, and courteous drivers. Customers can select vehicle types, schedule rides in advance, and view transparent fares online. With options ranging from economical cabs to premium sedans and SUVs, this booking service prioritizes comfort, safety, and convenience for airport commutes. 24/7 availability makes it suitable for flights at any time of day or night."
  },
  {
    "name": "Pune to Mumbai Outstation Booking",
    "description": "Pune to Mumbai Outstation Booking provides reservations for long-distance intercity travel, offering both one-way and round-trip options. Customers can choose from a fleet of hatchbacks, sedans, SUVs, and luxury vehicles to suit their comfort and budget. The service includes professional drivers, fare transparency, and the ability to track bookings online. It is ideal for families, corporate travelers, and tourists seeking a reliable and convenient solution for long-distance travel between Pune and Mumbai."
  },
  {
    "name": "Pune to Mumbai Luxury Cab Booking",
    "description": "Pune to Mumbai Luxury Cab Booking offers premium vehicles such as BMW, Audi, and Mercedes for passengers seeking an upscale travel experience. The service includes highly trained chauffeurs, spacious and comfortable interiors, and transparent fare details. Customers can easily book online, schedule trips, and access 24/7 customer support. Ideal for business executives, VIPs, or special occasions, Luxury Cab Booking ensures an elegant, secure, and hassle-free journey between Pune and Mumbai."
  },
  {
    "name": "Affordable Pune to Mumbai Taxi Booking",
    "description": "Affordable Pune to Mumbai Taxi Booking provides budget-friendly cab options without compromising on quality or safety. Customers can book compact cars, sedans, or SUVs at competitive rates with transparent fare details. The service includes trained drivers, clean vehicles, and reliable pickups. With online booking, real-time tracking, and flexible payment methods, this service is ideal for students, families, and regular travelers seeking dependable and cost-effective transportation between Pune and Mumbai."
  },
  {
    "name": "Pune to Mumbai 24x7 Cab Booking",
    "description": "Pune to Mumbai 24x7 Cab Booking ensures that travelers can book cabs at any time of the day or night. The service provides instant online booking, fare transparency, and options for various vehicle types including sedans, SUVs, and luxury cars. Experienced drivers, clean and comfortable vehicles, and reliable pickups make this service convenient for late-night flights, early morning trips, or emergency travel. Round-the-clock support guarantees a smooth and stress-free journey."
  },
  {
    "name": "Pune to Mumbai Online Taxi Hire",
    "description": "Pune to Mumbai Online Taxi Hire allows customers to reserve taxis digitally with ease. Users can choose from multiple vehicle types, schedule pickups, and get real-time fare estimates. The platform supports secure payments, cancellation, and rescheduling options. By providing professional drivers, clean and well-maintained cars, and transparent pricing, this service ensures safe and convenient travel for both personal and business purposes between Pune and Mumbai."
  },
  {
    "name": "Pune to Mumbai Car Booking Site",
    "description": "Pune to Mumbai Car Booking Site offers a comprehensive online platform for booking various types of vehicles, including hatchbacks, sedans, SUVs, and luxury cars. Customers can view fare details, schedule rides, and confirm bookings instantly. The service includes professional drivers, clean and comfortable vehicles, and 24/7 customer support. Ideal for one-way trips, round trips, airport transfers, or outstation travel, this platform ensures convenience, reliability, and transparency for travelers commuting between Pune and Mumbai."
  }
],
"tableData": [
  ["Pune to Mumbai Online Cab Booking", "Pune to Mumbai Cab Service"],
  ["Pune to Mumbai Taxi Online", "Pune to Mumbai Car Rental Booking"],
  ["Pune to Mumbai Innova Booking", "Pune to Mumbai Sedan Booking"],
  ["Pune to Mumbai Ertiga Booking", "Pune to Mumbai One Way Booking"],
  ["Pune to Mumbai Airport Cab Booking", "Pune to Mumbai Outstation Booking"],
  ["Pune to Mumbai Luxury Cab Booking", "Affordable Pune to Mumbai Taxi Booking"],
  ["Pune to Mumbai 24x7 Cab Booking", "Pune to Mumbai Online Taxi Hire"],
  ["Pune to Mumbai Car Booking Site", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Mumbai Online Cab Booking",
    "WhyChoosedescription": "Sai Trupti Cabs Pvt Ltd enables seamless online bookings for cab services from Pune to Mumbai, combining convenience, responsiveness, and reliability."
  },
  {
    "WhyChooseheading": "Instant Online Booking Confirmation",
    "WhyChoosedescription": "Book your Pune‑to‑Mumbai cab via our website or WhatsApp and receive immediate confirmation of your vehicle, driver, and pickup details."
  },
  {
    "WhyChooseheading": "Transparent Online Fare Display",
    "WhyChoosedescription": "View your fare, inclusive of tolls and taxes, upfront when booking online — no hidden costs or surprises at drop‑off."
  },
  {
    "WhyChooseheading": "Wide Vehicle Choice Online",
    "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs or premium cars for your Pune‑to‑Mumbai journey — all available to book online with easy filtering by capacity and budget."
  },
  {
    "WhyChooseheading": "24/7 Online Customer Support & Modifications",
    "WhyChoosedescription": "Our online support team is available round the clock to help you with bookings, route queries, or modifications to your Pune‑Mumbai trip."
  },
  {
    "WhyChooseheading": "Track Your Ride & Driver Details Online",
    "WhyChoosedescription": "After booking, access driver name, car registration and live status online so you can travel from Pune to Mumbai with confidence."
  },
  {
    "WhyChooseheading": "Flexible Cancellation and Rescheduling Online",
    "WhyChoosedescription": "Make changes to your Pune‑Mumbai cab booking via our online portal or WhatsApp — we offer flexible policies to accommodate your plans."
  },
  {
    "WhyChooseheading": "Safe & Secure Payment Options",
    "WhyChoosedescription": "Pay online or via driver with multiple payment options: UPI, card, or cash — ensuring your booking from Pune to Mumbai is convenient and secure."
  }
]




















  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pune to Mumbai online cab booking services?',
    answer: 'Yes, Sai Trupti Cabs  provides easy and reliable Pune to Mumbai online cab booking services for one way, round trip, and airport transfers.',
  },
  {
    question: 'How can I book a Pune to Mumbai cab online with Sai Trupti Cabs?',
    answer: 'You can conveniently book your Pune to Mumbai cab online through our official website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of cabs are available for Pune to Mumbai online booking?',
    answer: 'We offer a wide range of cabs including hatchbacks, sedans, SUVs, tempo travellers, and luxury cars to suit your travel comfort and budget.',
  },
  {
    question: 'Are the drivers professional and experienced for Pune to Mumbai trips?',
    answer: 'Yes, all our drivers are trained, courteous, and experienced in driving on the Pune–Mumbai Expressway, ensuring a safe and comfortable ride.',
  },
  {
    question: 'Can I book a Pune to Mumbai cab online for airport transfers?',
    answer: 'Certainly. You can book Pune to Mumbai airport transfers online for both domestic and international terminals in Mumbai.',
  },
  {
    question: 'Is Pune to Mumbai online cab booking available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 online cab booking from Pune to Mumbai for your convenience and travel flexibility.',
  },
  {
    question: 'What are the Pune to Mumbai cab fares when booking online?',
    answer: 'Our Pune to Mumbai cab fares start from ₹1,500 for hatchbacks, ₹1,800–₹2,500 for sedans, and ₹3,000 onwards for SUVs, depending on vehicle type and travel needs.',
  },
  {
    question: 'What payment methods are accepted for Pune to Mumbai online cab booking?',
    answer: 'We accept online payments through UPI, credit/debit cards, bank transfers, and digital wallets for a smooth booking experience.',
  },
  {
    question: 'What safety and hygiene protocols are followed during Pune to Mumbai cab rides?',
    answer: 'All our vehicles are sanitized before every trip, and our drivers follow strict safety and hygiene guidelines for your peace of mind.',
  },
  {
    question: 'Is customer support available after booking Pune to Mumbai cabs online?',
    answer: 'Yes, our 24×7 customer support team is available to assist you before, during, and after your Pune to Mumbai journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohan Bhat',
    feedback: 'Online cab booking from Pune to Mumbai with Sai Trupti Cabs was quick and simple. The service was excellent and the driver was professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Mehta',
    feedback: 'I booked my Pune to Mumbai cab online through Sai Trupti Cabs. Great experience — clean car, safe drive, and easy online payment.',
    rating: 5,
  },
];























































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Online Cab Booking",
  "image": "https://saitrupticabs.com/assets/images/pune-to-mumbai-online-cab-booking.jpg",
  "description": "Book Pune to Mumbai Online Cab with Sai Trupti Cabs for an easy, quick, and affordable travel experience. Choose from AC Sedans, SUVs, and Luxury Cars for one-way, round-trip, or airport transfers. Enjoy instant confirmation, transparent fares, and 24/7 customer support for a hassle-free ride.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "16512"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2399",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-mumbai-online-cab-booking"
  }
};




  return (
    <div>
      
<Helmet>
  <title>Pune to Mumbai Online Cab Booking | Quick & Affordable | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai Online Cab with Sai Trupti Cabs for an easy, quick, and affordable travel experience. Choose from AC Sedans, SUVs, and Luxury Cars for one-way, round-trip, or airport transfers. Enjoy instant confirmation, transparent fares, and 24/7 customer support for a hassle-free ride." 
  />
  <meta 
    name="keywords" 
    content="Pune to Mumbai Online Cab Booking, Pune to Mumbai Cab Service, Pune to Mumbai Taxi Online, Pune to Mumbai Car Rental Booking, Pune to Mumbai Innova Booking, Pune to Mumbai Sedan Booking, Pune to Mumbai Ertiga Booking, Pune to Mumbai One Way Booking, Pune to Mumbai Airport Cab Booking, Pune to Mumbai Outstation Booking, Pune to Mumbai Luxury Cab Booking, Affordable Pune to Mumbai Taxi Booking, Pune to Mumbai 24x7 Cab Booking, Pune to Mumbai Online Taxi Hire, Pune to Mumbai Car Booking Site" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/7.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaionlinecabbooking;